import { render, staticRenderFns } from "./BackStaffQuestionnaire.vue?vue&type=template&id=469bbc33&scoped=true&"
import script from "./BackStaffQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./BackStaffQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./BackStaffQuestionnaire.vue?vue&type=style&index=0&id=469bbc33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469bbc33",
  null
  
)

export default component.exports